import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';

import { UserSettingsResponse, UserSettingsUpdateInput } from '@repo/types';
import { BaseApiService } from './base-api.service';

export class UserSettingsService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.USER_SETTINGS.BASE, axios);
  }

  async getUserSettings(): Promise<UserSettingsResponse> {
    return this.get<UserSettingsResponse>('');
  }

  async createUserSettings(data: UserSettingsUpdateInput): Promise<UserSettingsResponse> {
    return this.post<UserSettingsResponse, UserSettingsUpdateInput>('', data);
  }

  async updateUserSettings(data: UserSettingsUpdateInput): Promise<UserSettingsResponse> {
    return this.patch<UserSettingsResponse, UserSettingsUpdateInput>('', data);
  }

  async deleteUserSettings(): Promise<{ message: string }> {
    return this.delete<{ message: string }>('');
  }
}
